/* Buy-box accordions: smooth open/close on native <details>, label lightbox. No deps. */
(function(){
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(root.__dacc)return;root.__dacc=1;
    root.querySelectorAll('.dacc-i').forEach(function(d){
      var s=d.querySelector('summary'),b=d.querySelector('.dacc-b');
      s.addEventListener('click',function(e){
        if(rm||!b.animate)return;
        e.preventDefault();
        var opening=d.__anim?!d.__opening:!d.open;
        if(d.__anim){d.__anim.onfinish=null;d.__anim.cancel();}
        d.__opening=opening;
        if(opening){d.open=true;}
        b.style.height='';var h=b.scrollHeight;
        var a=b.animate(opening?[{height:'0px',opacity:0},{height:h+'px',opacity:1}]:[{height:h+'px',opacity:1},{height:'0px',opacity:0}],{duration:opening?320:240,easing:'cubic-bezier(.2,.7,.2,1)'});
        d.__anim=a;
        a.onfinish=function(){d.__anim=null;if(!opening)d.open=false;};
      });
    });
    var dlg=root.querySelector('[data-dacc-dlg]'),btn=root.querySelector('[data-dacc-sfp]');
    if(dlg&&btn){
      btn.addEventListener('click',function(){
        if(dlg.showModal){dlg.showModal();}else{window.open(dlg.querySelector('img').src,'_blank');}
      });
      dlg.addEventListener('click',function(e){if(e.target===dlg||e.target.closest('[data-dacc-x]'))dlg.close();});
    }
  }
  function all(){document.querySelectorAll('[data-dacc]').forEach(init);}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
